<template>
  <div class="sprite">
    <canvas v-el:canvas></canvas>
  </div>
</template>

<script>
import sprite from 'stupid-sprite'
import tick from 'stupid-tick'

export default {
  name: 'Sprite',
  data () {
    return {
      isHovered: false,
      endFrame: undefined,
      tick: undefined,
      sprite: undefined
    }
  },
  props: {
    images: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    playing: {
      type: Boolean,
      default: true
    }
  },
  ready () {
    this.tick = tick({fps: 25})

    this.sprite = sprite({
      tick: this.tick,
      canvas: this.$els.canvas,
      loop: true
    })

    this.sprite
      .load(this.images)
      .success(this.success)
  },
  beforeDestroy () {
    this.tick = null
    this.sprite = null
  },
  methods: {
    success () {
      this.endFrame = this.sprite.getEndFrame()
      this.sprite.play(0)
    }
  },
  watch: {
    playing () {
      !this.playing ? this.sprite.pause() : this.sprite.play()
    }
  }
}
</script>

<style lang="scss" scoped>
.sprite {
  position: absolute;
  width: 100%;
  height: 100%;

  canvas {
    width: 100%;
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// Sprite.vue?ad5dbf84